import comp from "./PlannerOverviewSkeletonLoader";
export default comp;
